export default __webpack_public_path__ + "static/media/team.6c9991c0.jpeg";